import React from "react"
import "./third.css"

function Third(props){
    const b = props.name;
    const c = props.id;


    const a = <div><button  id ={c} className={"task"} onClick={function (){
        const d = document.getElementById(c);
        d.className = "strike";



    }}>{b}</button><button className={"close"} id = {c + "button"} onClick={function (){
        document.getElementById(c+ "button").remove();
        document.getElementById(c).remove();
    }}>×</button></div>
    return a

}


export default Third
